import BlogCard from "./BlogCard";

export default function RelatedArticles({ recentBlogs }) {
    return (
        <section className='cont-sec'>
            <div className='container'>
                <div className='mn-head'>
                    <h5>Related articles</h5>
                </div>
                <ul>
                    {
                        recentBlogs?.map((blog, index) => (
                            <BlogCard key={index} blog={blog} />
                        ))
                    }
                </ul>
            </div>
        </section>
    );
}